<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" :class="containerClass">
                    <div class="modal-close-container">
                        <div class="modal-close-btn" @click="$emit('close')">
                            <i class="fa fa-times-circle close-icon text-danger"></i>
                        </div>
                    </div>
                    <div class="modal-content-inside">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal-Dialog",
        props: ['containerClass']
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        max-width: 60%;
        padding: 20px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .modal-close-container {
        text-align: right;
        margin: -32px -31px 32px 0;
        height: 0;
    }

    .modal-close-btn {
        background: white;
        width: 29px;
        height: 22px;
        border-radius: 9999px;
        line-height: 30px;
        cursor: pointer;
        margin: 0;
        float: right;
    }

    .close-icon {
        line-height: 0;
        height: 30px;
        font-size: 35px;
        margin-top: 12px;
    }

    .modal-content-inside{
        overflow: auto;
    }
</style>